import {NgModule} from '@angular/core';
import {NoImageDirectiveGeneric} from './no-image';

@NgModule({
    declarations: [NoImageDirectiveGeneric],
    exports: [NoImageDirectiveGeneric]
})
export class NoImageDirectiveModuleGeneric {}
